export default __webpack_public_path__ + "static/media/smiley-text.d6cb7e59.svg";